import { challengeTypes } from '@freecodecamp/shared/config/challenge-types';

// Show a single project in a certification layout

const projectBasedChallengeTypes = [
  challengeTypes.frontEndProject,
  challengeTypes.backEndProject,
  challengeTypes.jsProject,
  challengeTypes.pythonProject,
  challengeTypes.codeAllyCert,
  challengeTypes.multifileCertProject,
  challengeTypes.exam,
  challengeTypes.codeAllyPractice,
  challengeTypes.multifilePythonCertProject,
  challengeTypes.lab,
  challengeTypes.jsLab,
  challengeTypes.pyLab,
  challengeTypes.dailyChallengeJs,
  challengeTypes.dailyChallengePy,
  challengeTypes.freeCodeCampOsPractice,
  challengeTypes.freeCodeCampOsCert
];

export const isProjectBased = (
  challengeType: number,
  blockDashedName: unknown = null
) => {
  // Is project based but should be collapsible, this differs from the
  // other projects which are not collapsible.
  if (blockDashedName === 'take-home-projects') return false;

  return projectBasedChallengeTypes.includes(challengeType);
};
